
import { Component, Vue, Prop } from 'vue-property-decorator';

import ExLoading from '@/globalComponents/ExLoading/index.vue';

@Component({
  components: {
    ExLoading
  }
})
export default class ContentLoader extends Vue {
  @Prop({ default: 4 }) quantityLoading!: number;
}
